export var ProviderStatus;
(function (ProviderStatus) {
    ProviderStatus["UP_TO_DATE"] = "Al d\u00EDa";
    ProviderStatus["AT_RISK"] = "En riesgo";
    ProviderStatus["NON_COMPLIANT"] = "Incumplido";
    ProviderStatus["OBSOLETE"] = "Obsoleto";
})(ProviderStatus || (ProviderStatus = {}));
export var ComplianceStatus;
(function (ComplianceStatus) {
    ComplianceStatus["PENDING"] = "Pendiente";
    ComplianceStatus["SUBMITTED"] = "Entregado";
    ComplianceStatus["CURRENT"] = "Vigente";
    ComplianceStatus["AT_RISK"] = "En riesgo";
    ComplianceStatus["EXPIRED"] = "Vencido";
})(ComplianceStatus || (ComplianceStatus = {}));
